import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Spinner,
  Text,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { TbTransferVertical } from "react-icons/tb";
import TransferInGameModal from "./TransferInGameModal";
import { COMMON_WEB_PATH } from "../../../../constant";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import { TRANSFER_PENDING } from "../../../../redux/action/member/memberAction";
import useTransferMode from "../../../../hook/useTransferMode";
import useIsLandScapeMachine from "../../../../hook/useIsLandScapeMachine";

/**
 * @description 遊戲中轉點的按鈕
 * @returns
 */
const TransferButton = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [openModal, setOpenModal] = useState(false);
  const [dragStartTime, setDragStartTime] = useState(0);

  const isTransferInGameState = useSelector(
    (state) => state.isTransferInGameState
  );
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  const isLandscapeMachine = useIsLandScapeMachine();

  const { testFunction } = isMemberInfo || {}; //是否可以用此功能

  // 檢查是否為轉帳錢包模式
  const isTransferMode = useTransferMode();

  const dispatch = useDispatch();

  const handleOpenModal = async () => {
    setOpenModal(true);
  };

  const handleCloseModal = async () => {
    setOpenModal(false);
  };

  /**
   * @description 檢查是否有轉點請求存在，邏輯上是用localStorage紀錄request_id，當用戶重整網頁時，會根據request_id是否存在來打訊息至websocket獲取轉點結果
   */
  const transferRequestIsExist = localStorage.getItem(
    "transfer_in_game_request_id"
  );

  const handleStart = () => {
    setDragStartTime(Date.now());
  };

  const handleStop = () => {
    if (Date.now() - dragStartTime < 200) {
      handleOpenModal();
    }
  };

  useEffect(() => {
    if (transferRequestIsExist) {
      dispatch(TRANSFER_PENDING());
    }
  }, [transferRequestIsExist, dispatch]);

  return testFunction && isTransferMode ? (
    <>
      <Draggable onStart={handleStart} onStop={handleStop}>
        <Box
          position={"absolute"}
          left={isLandscapeMachine ? "unset" : "0px"}
          right={isLandscapeMachine ? "0px" : "unset"}
          bottom={"0px"}
          bgImage={`url('${COMMON_WEB_PATH}/911TW/titleBG5.webp')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          minW={{ base: "48px", md: "48px" }}
          h={"52px"}
          rounded={"5px"}
          gap={"10px"}
          alignItems={"center"}
          justifyContent={"center"}
          cursor="pointer"
          className={`!flex`}
          zIndex={9999}
          sx={{
            "& > *": {
              color: "text-yellow-500",
            },
          }}
          px="5px"
        >
          {isTransferInGameState === "pending" ? (
            <Tooltip label={i18n("轉點處理中")}>
              <Flex alignItems={"center"}>
                <Spinner />
              </Flex>
            </Tooltip>
          ) : (
            <Tooltip label={i18n("轉點至遊戲中")}>
              <Flex alignItems={"center"}>
                <Icon as={TbTransferVertical} />
              </Flex>
            </Tooltip>
          )}
        </Box>
      </Draggable>
      {openModal && <TransferInGameModal onClose={handleCloseModal} />}
    </>
  ) : null;
};

export default TransferButton;
